import React, { Component } from 'react'
import PropTypes from 'prop-types'
import size from 'lodash/size'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import range from 'lodash/range'
import './index.scss'

/**
 * - This component expects to be given 1-based page data
 * - If your pagination endpoints are 0-based, the component that implements
 *   <Pagination /> needs to do any necessary index conversions
 */
class Pagination extends Component {
  constructor (props) {
    super(props)
    const { page } = props
    this.state = { page }
  }

  static getDerivedStateFromProps (props, state) {
    if (state.page !== props.page) {
      return {
        page: props.page,
      }
    }
    return state
  }

  setPage = (page) => {
    const { props } = this
    const { onChangePage } = props
    this.setState(() => ({ page }))
    onChangePage(page)
  }

  getPagination = () => {
    const { props, state } = this
    const { page: currentPage } = state
    const { totalItemCount, itemsPerPage, pagesToShow = 10 } = props
    const totalPages = Math.ceil(totalItemCount / itemsPerPage)

    let startPage
    let endPage
    if (totalPages <= pagesToShow) {
      // less than 10 total pages so show all
      startPage = 1
      endPage = totalPages
      // more than 10 total pages so calculate start and end pages
    } else if (currentPage <= 6) {
      startPage = 1
      endPage = pagesToShow
    } else if (currentPage + 4 >= totalPages) {
      startPage = totalPages - 9
      endPage = totalPages
    } else {
      startPage = currentPage - 5
      endPage = currentPage + 4
    }

    // calculate start and end item indexes
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = Math.min(startIndex + itemsPerPage - 1, totalItemCount - 1)
    // create an array of pages for paginationData
    const pages = range(startPage, endPage + 1) // range() is not inclusive for endIndex

    return {
      totalPages,
      startPage,
      endPage,
      startIndex,
      endIndex,
      pages,
      currentPage,
    }
  }

  render () {
    const { state, setPage, getPagination } = this
    const { page: currentPage } = state
    const { pages, totalPages } = getPagination()
    if (isEmpty(pages) || size(pages) <= 1) {
      // don't display paginationData if there is only 1 page
      return null
    }
    return (
      <ul className="mui-list--unstyled mui-list--inline pagination">
        <li className={currentPage === 1 ? 'pagination__item--disabled' : ''}>
          <a onClick={() => setPage(1)}>First</a>
        </li>
        <li className="pagination__item--divider">|</li>
        <li className={currentPage === 1 ? 'pagination__item--disabled' : ''}>
          <a onClick={() => setPage(currentPage - 1)}>Previous</a>
        </li>
        <li className="pagination__item--divider">|</li>
        {map(pages, (page, index) => <li key={index} className={currentPage === page ? 'pagination__item--active' : ''}>
            <a onClick={() => setPage(page)}>{page}</a>
          </li>)}
        <li className="pagination__item--divider">|</li>
        <li className={currentPage === totalPages ? 'pagination__item--disabled' : ''}>
          <a onClick={() => setPage(currentPage + 1)}>Next</a>
        </li>
        <li className="pagination__item--divider">|</li>
        <li className={currentPage === totalPages ? 'pagination__item--disabled' : ''}>
          <a onClick={() => setPage(totalPages)}>Last</a>
        </li>
      </ul>
    )
  }
}

Pagination.propTypes = {
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pagesToShow: PropTypes.number,
  itemsPerPage: PropTypes.number.isRequired,
  totalItemCount: PropTypes.number.isRequired,
}

export default Pagination
